<template>
    <div id="home">
        <div id="lc-minimized" class="minimized" v-on:click="minimizeWindow()">
            <img class="chatIcon" src="https://topcrane.com/frontend/images/chatIcon.png">
<!--            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
                 xmlns:svgjs="http://svgjs.com/svgjs" width="512" height="512" x="0" y="0" viewBox="0 0 477.867 477.867"
                 style="enable-background:new 0 0 512 512" xml:space="preserve" className=""><g>
            <g xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path
                        d="M426.667,0.002H51.2C22.923,0.002,0,22.925,0,51.202v273.067c0,28.277,22.923,51.2,51.2,51.2h60.587l-9.284,83.456    c-1.035,9.369,5.721,17.802,15.09,18.837c4.838,0.534,9.674-1.023,13.292-4.279l108.919-98.014h186.863    c28.277,0,51.2-22.923,51.2-51.2V51.202C477.867,22.925,454.944,0.002,426.667,0.002z M443.733,324.269    c0,9.426-7.641,17.067-17.067,17.067H233.25c-4.217,0.001-8.284,1.564-11.418,4.386l-80.452,72.414l6.434-57.839    c1.046-9.367-5.699-17.809-15.067-18.856c-0.63-0.07-1.263-0.106-1.897-0.105H51.2c-9.426,0-17.067-7.641-17.067-17.067V51.202    c0-9.426,7.641-17.067,17.067-17.067h375.467c9.426,0,17.067,7.641,17.067,17.067V324.269z"
                        fill="#000000" data-original="#000000" style=""></path>
                </g>
            </g>
            </g></svg>-->
        </div>
        <div id="lc" class="minimized">
            <div id="lc-header">
                <div>
                    <img src="https://topcrane.com/frontend/images/ChatLogo.png"/>
                </div>
                <button id="minimize" v-on:click="minimizeWindow()">
                    <svg fill="#5a6976" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                        <path d="M0 0h24v24H0z" fill="none"/>
                    </svg>
                </button>
            </div>
            <div id="chat" v-on:scroll="handleScroll()">
                <div id="chatLowerHtml">
                    <div class="chatStartForm" id="chatStartForm">
                        <p id="acceptChatText">Please provide some information</p>
                        <p class="d-none" id="nonAcceptChatText">There is no one currently available at Top Crane. Please enter your contact information and we will get back to you.</p>

                            <div class="form-group">
                                <label>First Name *</label>
                                <input type="text" class="form-control" id="first_name" name="first_name" placeholder="Enter Your First Name">
                                <p class="text-danger" id="first_name_field"></p>
                            </div>
                            <div class="form-group">
                                <label>Last Name *</label>
                                <input type="text" class="form-control" id="last_name" name="last_name" placeholder="Enter Your Last Name">
                                <p class="text-danger" id="last_name_field"></p>
                            </div>
                            <div class="form-group">
                                <label>Email *</label>
                                <input type="email" class="form-control" id="email" name="email" placeholder="Enter Your Email">
                                <p class="text-danger" id="email_field"></p>
                            </div>
                            <div class="form-group" id="acceptChatTextDiv">
                                <label>Phone *</label>
                                <input type="text" class="form-control" id="phone" name="phone" placeholder="Enter Your Phone No">
                                <p class="text-danger" id="phone_field"></p>
                            </div>
<!--                            <div class="form-group d-none" id="nonAcceptChatTextDiv">
                                <label>Message *</label>
                                <textarea class="form-control" id="message" name="message" placeholder="Enter Your Message"></textarea>
                                <p class="text-danger" id="message_field"></p>
                            </div>-->
                            <div class="form-group">
                                <button id="start-chat-button" v-on:click="chatStart">Start a conversation</button>
                            </div>

                    </div>


                    <p class="d-none" id="ticketMessage">Thank you. Your message has been sent. Someone from Top Crane will contact you soon.</p>


                </div>


                <div id="lc-loader" ref="chatLoader">
                    <svg className="resizable-svg" viewBox="0 0 72 99" xmlns="http://www.w3.org/2000/svg">
                        <g className="circle">
                            <rect className="circle-background" width="72" height="72"/>
                            <path className="letter-c" d="M49.8,45c-2.9,4.5-8,7.5-13.8,7.5c-9.1,0-16.5-7.4-16.5-16.5c0-9.1,7.4-16.5,16.5-16.5c5.8,0,10.9,3,13.8,7.5
        h21C66.9,11.5,52.8,0,36,0C16.1,0,0,16.1,0,36s16.1,36,36,36c16.8,0,30.9-11.5,34.9-27H49.8z"
                                  shape-rendering="geometricPrecision"
                            />
                        </g>
                    </svg>
                </div>

<!--                <div className="read">-->
<!--                    Read-->
<!--                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"-->
<!--                         xmlns:svgjs="http://svgjs.com/svgjs" width="512" height="512" x="0" y="0" viewBox="0 0 512 512"-->
<!--                         style="enable-background:new 0 0 512 512" xml:space="preserve" className=""><g><path xmlns="http://www.w3.org/2000/svg" d="m369.164062 174.769531c7.8125 7.8125 7.8125 20.476563 0 28.285157l-134.171874 134.175781c-7.8125 7.808593-20.472657 7.808593-28.285157 0l-63.871093-63.875c-7.8125-7.808594-7.8125-20.472657 0-28.28125 7.808593-7.8125 20.472656-7.8125 28.28125 0l49.730468 49.730469 120.03125-120.035157c7.8125-7.808593 20.476563-7.808593 28.285156 0zm142.835938 81.230469c0 141.503906-114.515625 256-256 256-141.503906 0-256-114.515625-256-256 0-141.503906 114.515625-256 256-256 141.503906 0 256 114.515625 256 256zm-40 0c0-119.394531-96.621094-216-216-216-119.394531 0-216 96.621094-216 216 0 119.394531 96.621094 216 216 216 119.394531 0 216-96.621094 216-216zm0 0" fill="#000000" data-original="#000000" style="" className=""></path></g></svg>-->
<!--                </div>-->
<!--                <div className="currentDay"><span>Today</span></div>-->
            </div>

            <div id="typing_indicator"></div>

            <div id="footer" style="display: none;">
                <div id="textarea-wrapper" style="display: none;">
                    <textarea placeholder="Type message" id="message-input" ref="input" @keyup.enter="sendCustomerMessage" disabled></textarea>
                    <button id="send-button" v-on:click="sendCustomerMessage" disabled>
                        <svg fill="#b2bbc6" height="24" viewBox="0 0 24 24" width="24"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
                            <path d="M0 0h24v24H0z" fill="none"/>
                        </svg>
                    </button>
                </div>
<!--                <button id="start-chat-button" v-on:click="chatStart">Start new chat</button>-->
            </div>
        </div>
    </div>
</template>

<script type="application/javascript">

import './livechat.css'
import './polyfill'
import {init, debug} from '@livechat/customer-sdk'
import * as DOMElements from './DOMElements'
import * as DOMOperations from './DOMOperations'


export default {
    name: 'app',
     data(){
        return {
            historyStates: {
                DONE: 'DONE',
                INACTIVE: 'INACTIVE',
                LOADING: 'LOADING',
            },
            state: {
                chat: null,
                active: false,
                activating: false,
                users: {},
                pendingMessages: [],
                customerId: null,
                historyStatus: 'INACTIVE',
                history: null,
            },
            customerName : null,
            availability : "online",
            isFirst: 0,
            logoLoader : `
                        <svg class="resizable-svg" viewBox="0 0 72 99" xmlns="http://www.w3.org/2000/svg">
                        <style type="text/css">


                        .circle-background {
                        fill: transparent;
                        }

                        .letter-c {
                        fill: #373737;
                        }
                        </style>

                        <g class="circle">
                        <rect class="circle-background" width="72" height="72" />
                        <path class="letter-c" d="M49.8,45c-2.9,4.5-8,7.5-13.8,7.5c-9.1,0-16.5-7.4-16.5-16.5c0-9.1,7.4-16.5,16.5-16.5c5.8,0,10.9,3,13.8,7.5
                        h21C66.9,11.5,52.8,0,36,0C16.1,0,0,16.1,0,36s16.1,36,36,36c16.8,0,30.9-11.5,34.9-27H49.8z" shape-rendering="geometricPrecision"
                        />
                        </g>
                        </svg>
                        `
        }
    },
    methods: {
        sendMessage(chat, id, text){
            const message = {customId: id, text, type: 'message'}

            sdk.sendEvent({chatId: chat, event: message}).then(
                event => {
                    const author = this.state.users[event.authorId]
                    let name = author.name ? author.name : this.customerName;

                    DOMOperations.appendMessage(DOMOperations.createMessage(event.id, event.text, event.createdAt,'customer', name))

                }
            )
        },
        minimizeWindow() {
            document.getElementById('lc').classList.toggle('minimized');
            document.getElementById('lc-minimized').classList.toggle('minimized');
            if(this.isFirst == 0){
                DOMOperations.scrollToBottom()
                this.isFirst = 1;
            }

        },
        chatStart() {
            const sdk = init({licenseId: 12810012, clientId: '9fcdd0c471191609e67b14cf69a12128'})
            window.sdk = sdk

            sdk.on('connected', () => {
                sdk.listChats().then(({chatsSummary}) => {
                    document.getElementById('first_name_field').innerText = "";
                    document.getElementById('last_name_field').innerText = "";
                    document.getElementById('email_field').innerText = "";
                    document.getElementById('phone_field').innerText = "";
                    // document.getElementById('message_field').innerText = "";

                    const first_name = document.getElementById('first_name').value;
                    const last_name = document.getElementById('last_name').value;
                    const email = document.getElementById('email').value;
                    const phone = document.getElementById('phone').value;
                    // const message = document.getElementById('message').value;
                    if(first_name == ""){
                        document.getElementById('first_name_field').innerText = "Please fill in required fields.";
                    }
                    if(last_name == ""){
                        document.getElementById('last_name_field').innerText = "Please fill in required fields.";
                    }

                    function validateEmail(email)
                    {
                        var re = /\S+@\S+\.\S+/;
                        return re.test(email);
                    }

                    if(email == ""){
                        document.getElementById('email_field').innerText = "Please fill in required fields.";
                    }
                    else if(validateEmail(email) != true){
                        document.getElementById('email_field').innerText = "Please enter valid email.";
                    }

                    if(phone == ""){
                        document.getElementById('phone_field').innerText = "Please fill in required fields.";
                    }

                    // if(message == ""){
                    //     document.getElementById('message_field').innerText = "Please fill in required fields.";
                    // }

                    if(this.availability =="online"){
                        if(first_name != "" && last_name != "" && email != "" && validateEmail(email) == true && phone !="") {
                            const properties = {
                                name: first_name + ' ' + last_name,
                                email: email,
                                sessionFields: {
                                    phone: phone,
                                },
                            }
                            if (this.state.chat) {
                                sdk.resumeChat({
                                    chat: {
                                        id: chatsSummary[0].id,
                                        thread: {
                                            events: [],
                                        },
                                    },
                                }).then(chat => {
                                    sdk.updateCustomer(properties)
                                    this.customerName = properties.name;
                                    // console.log(chat)
                                })
                                    .catch(error => {
                                        // console.log(error)
                                    })
                                // return

                            } else {
                                sdk.startChat({
                                    chat: {
                                        thread: {
                                            events: [],
                                        },
                                    },
                                }).then(chat => {
                                    sdk.updateCustomer(properties)
                                    this.customerName = properties.name;
                                    // console.log(chat)
                                })
                                    .catch(error => {
                                        // console.log(error)
                                    })
                            }
                            this.state.chat = chatsSummary[0].id
                        }
                    }
                    else{
                        if(first_name != "" && last_name != "" && email != "" && validateEmail(email) == true && phone !=""){

                            sdk.sendTicketForm({
                                    filledForm: {
                                        type: 'filled_form',
                                        formId: '',
                                        fields: [
                                            {
                                                type: 'subject',
                                                id: '0',
                                                label: 'Subject:',
                                                answer: 'Query',
                                            },
                                            {
                                                type: 'name',
                                                id: '1',
                                                label: 'Name:',
                                                answer: first_name + ' ' + last_name,
                                            },
                                            {
                                                type: 'email',
                                                id: '2',
                                                label: 'Your email:',
                                                answer: email,
                                            },
                                            {
                                                type: 'textarea',
                                                id: '3',
                                                label: 'Your message:',
                                                answer: 'Phone No. '+ phone,
                                            },
                                        ],
                                    },
                                })
                                .then(response => {
                                    document.getElementById('chatStartForm').style.display = 'none';
                                    document.getElementById('ticketMessage').classList.remove('d-none');

                                    // console.log(`Created a ticket with id: ${response.id}`)
                                })
                                .catch(error => {
                                    // console.log(error)
                                })
                        }

                    }


                })
            })

        },
        sendCustomerMessage(){
            const text = this.$refs.input.value
            this.$refs.input.value = ''

            if (text.trim().length > 0) {

                const messageId = `${Math.random() * 1000}`

                if (this.state.active) {
                    this.sendMessage(this.state.chat, messageId, text)

                } else {
                    if (!this.state.activating) {
                        this.chatStart()
                    }
                    this.state.pendingMessages.push({messageId, text})
                }

                const messageList = document.getElementById('chat');
                messageList.scrollTop = messageList.scrollHeight;
            }

        },
        handleScroll(){
            // const loader = document.getElementById('lc-loader');
            // loader.style.display = 'block';

            const isAgent = (user) => user.id !== this.state.customerId

            DOMOperations.delegate(
                '#lc',
                '.chat',
                'mousewheel',
                DOMOperations.throttle(300, function loadMore() {
                    const chatId = this.dataset.id
                    const chat = this.state.chats[chatId]

                    if (this.scrollTop < 50 && chat.historyStatus === this.historyStates.INACTIVE) {
                        loadHistory(chatId).catch(noop)
                    }
                }),
            )

            const loadHistory = (chat) => {
                return new Promise((resolve, reject) => {
                    this.state.historyStatus = this.historyStates.LOADING
                    this.state.history.next().then(
                        ({value: {threads}, done}) => {
                            if (!threads) {
                                return
                            }

                            const messages = getMessagesFromThreads(threads)

                            // loader.parentElement.removeChild(loader)
                            // loader.style.display = 'none';

                            const messageList = DOMOperations.getMessageList(chat)

                            const fromTheBottom = messageList.scrollHeight - (messageList.scrollTop + messageList.clientHeight)

                            DOMOperations.prependMessages(chat, messages)

                            messageList.scrollTop = messageList.scrollHeight - messageList.clientHeight - fromTheBottom

                            this.state.historyStatus = done ? this.historyStates.DONE : this.historyStates.INACTIVE
                            resolve()
                        },
                        (err) => {
                            this.state.historyStatus = this.historyStates.INACTIVE
                            reject(err)
                        },
                    )
                })
            }

            const getMessagesFromThreads = (threads) =>
                threads
                    .map(({events}) => events || [])
                    .reduce((acc, current) => [...acc, ...current], [])
                    .filter((event) => event.type === 'message')
                    .map((event) => {
                        const author = this.state.users[event.authorId]
                        return DOMOperations.createMessage(
                            event.id,
                            event.text,
                            event.createdAt,
                            isAgent(author) ? 'agent' : 'customer',
                            author.name,
                        )
                    })
            const messageList = document.getElementById('chat');
            if(messageList.scrollTop == 0){
                loadHistory(this.state.chat).then(() => DOMOperations.scrollToBottom())
            }
        }

    },
    mounted() {
        const loader = document.getElementById('lc-loader');
        loader.innerHTML = this.logoLoader

        const noop = () => {
        }

        const sdk = init({licenseId: 12810012, clientId: '9fcdd0c471191609e67b14cf69a12128'})
        window.sdk = sdk

        const isAgent = (user) => user.id !== this.state.customerId

        sdk.on('connected', ({ availability }) => {
            this.availability = availability;
            sdk.listChats().then(({chatsSummary, totalChats}) => {

                if (this.state.chat) {
                    return
                }

                document.getElementById('message-input').placeholder = 'Type message';
                document.getElementById('message-input').disabled = false;
                document.getElementById('send-button').disabled = false;
                if (totalChats === 0) {
                    // loader.style.display = 'none';
                    loader.parentElement.removeChild(loader)
                    document.getElementById('footer').style.display = 'block';
                    document.getElementById('chatStartForm').style.display = 'block';
                    if(availability =="offline"){
                            document.getElementById('acceptChatText').classList.add('d-none');
                            // document.getElementById('acceptChatTextDiv').classList.add('d-none');
                            document.getElementById('nonAcceptChatText').classList.remove('d-none');
                            // document.getElementById('nonAcceptChatTextDiv').classList.remove('d-none');
                            document.getElementById('start-chat-button').innerHTML = "Request a callback";
                    }
                    return
                }

                this.state.chat = chatsSummary[0].id
                this.state.active = chatsSummary[0].active

                loadInitialHistory().then(() => {
                    // loader.style.display = 'none';
                    loader.parentElement.removeChild(loader)
                    document.getElementById('footer').style.display = 'block';
                    if (!this.state.active) {
                        document.getElementById('textarea-wrapper').style.display = 'none';
                        document.getElementById('chatStartForm').style.display = 'block';
                        if(availability =="offline"){
                            document.getElementById('acceptChatText').classList.add('d-none');
                            // document.getElementById('acceptChatTextDiv').classList.add('d-none');
                            document.getElementById('nonAcceptChatText').classList.remove('d-none');
                            // document.getElementById('nonAcceptChatTextDiv').classList.remove('d-none');
                            document.getElementById('start-chat-button').innerHTML = "Request a callback";
                        }
                    } else {
                        document.getElementById('chatStartForm').style.display = 'none';
                        document.getElementById('textarea-wrapper').style.display = 'flex';
                        document.getElementById('message-input').focus();
                    }
                })
            })
        })
        sdk.on('connection_restored', noop)
        sdk.on('user_is_typing', noop)
        sdk.on('user_stopped_typing', noop)
        sdk.on('user_joined_chat', noop)
        sdk.on('user_left_chat', noop)

        sdk.on('customer_id', (id) => {
            this.state.customerId = id
        })

        sdk.on('incoming_typing_indicator', payload => {
            if (payload.typingIndicator.isTyping) {
                const author = this.state.users[payload.typingIndicator.authorId]
                document.getElementById('typing_indicator').innerText = author.name+" is typing...";
                // DOMOperations.scrollToBottom()
            } else {
                document.getElementById('typing_indicator').innerText = "";
            }
        })

        const onConnectionLost = () => {
            document.getElementById('message-input').placeholder = 'Disconnected';
            document.getElementById('message-input').disabled = true;
            document.getElementById('send-button').disabled = true;
        }

        sdk.on('connection_lost', () => {
            onConnectionLost()
        })

        sdk.on('diconnected', (reason) => {
            onConnectionLost()
        })

        sdk.on('user_data', (user) => {
            this.state.users[user.id] = user
        })

        sdk.on('incoming_chat', ({chat}) => handleChatStart(chat))

        sdk.on('incoming_event', ({event}) => {
            if (!this.state.chat || event.type !== 'message') {
                return
            }
            const author = this.state.users[event.authorId]
            if(isAgent(author)) {
                DOMOperations.appendMessage(
                    DOMOperations.createMessage(event.id, event.text, event.createdAt, 'agent', author.name),
                )
                DOMOperations.scrollToBottom()
            }
        })

        sdk.on('chat_deactivated', () => {
            this.state.active = false
            document.getElementById('textarea-wrapper').style.display = 'none';
            document.getElementById('chatStartForm').style.display = 'block';
            DOMOperations.scrollToBottom();
        })

        sdk.on('availability_updated', ({ availability }) => {
            this.availability = availability;
            if(availability =="offline"){
                document.getElementById('acceptChatText').classList.add('d-none');
                // document.getElementById('acceptChatTextDiv').classList.add('d-none');
                document.getElementById('nonAcceptChatText').classList.remove('d-none');
                // document.getElementById('nonAcceptChatTextDiv').classList.remove('d-none');
                document.getElementById('start-chat-button').innerHTML = "Request a callback";
            }
            else{
                document.getElementById('acceptChatText').classList.remove('d-none');
                // document.getElementById('acceptChatTextDiv').classList.remove('d-none');
                document.getElementById('nonAcceptChatText').classList.add('d-none');
                // document.getElementById('nonAcceptChatTextDiv').classList.add('d-none');
                document.getElementById('start-chat-button').innerHTML = "Start a conversation";
            }
        })

        sdk.on('customer_updated', customer => {
            customer.type = "customer";
            this.state.users[customer.id] = customer
            if (customer.name) {
                const customerName = document.getElementsByClassName('cName');
                $.each(customerName, function( key, value ) {
                    value.innerText = customer.name;
                });
            }
        })

        const handleChatStart = (chat) => {
            this.state.chat = chat.id
            this.state.historyStatus = this.historyStates.DONE
            this.state.active = true
            this.state.activating = false
            this.state.pendingMessages = []
            const messages = getMessagesFromThreads([chat.thread])
            messages.forEach((message) => DOMOperations.appendMessage(message))

            const messageList = document.getElementById('chat');
            messageList.scrollTop = messageList.scrollHeight;

            document.getElementById('chatStartForm').style.display = 'none';
            document.getElementById('textarea-wrapper').style.display = 'flex';
            document.getElementById('message-input').focus();
        }

        const loadHistory = (chat) => {
            return new Promise((resolve, reject) => {
                this.state.historyStatus = this.historyStates.LOADING
                this.state.history.next().then(
                    ({value: {threads}, done}) => {
                        if (!threads) {
                            return
                        }

                        const messages = getMessagesFromThreads(threads)
                        const messageList = DOMOperations.getMessageList(chat)

                        const fromTheBottom = messageList.scrollHeight - (messageList.scrollTop + messageList.clientHeight)

                        DOMOperations.prependMessages(chat, messages)

                        messageList.scrollTop = messageList.scrollHeight - messageList.clientHeight - fromTheBottom

                        this.state.historyStatus = done ? this.historyStates.DONE : this.historyStates.INACTIVE
                        resolve()
                    },
                    (err) => {
                        this.state.historyStatus = this.historyStates.INACTIVE
                        reject(err)
                    },
                )
            })
        }

        const getMessagesFromThreads = (threads) =>
            threads
                .map(({events}) => events || [])
                .reduce((acc, current) => [...acc, ...current], [])
                .filter((event) => event.type === 'message')
                .map((event) => {
                    const author = this.state.users[event.authorId]
                    return DOMOperations.createMessage(
                        event.id,
                        event.text,
                        event.createdAt,
                        isAgent(author) ? 'agent' : 'customer',
                        author.name,
                    )
                })

        const loadInitialHistory = () => {
            const chatId = this.state.chat

            this.state.history = sdk.getChatHistory({chatId})

            const loadLatestHistory = () => loadHistory(chatId).then(() => DOMOperations.scrollToBottom())

            return loadLatestHistory()
                .catch(() => loadLatestHistory())
                .catch(noop)
        }

        window.addEventListener('beforeunload', sdk.disconnect)
    }
};

</script>
